<script setup lang="ts">

import type Building from '@/types/Building.ts'
import GenericIconWithColoredNumber from '@/components/Elements/Images/Icons/GenericIconWithColoredNumber.vue'

/**
 * Props
 */
defineProps<{
  building: Building
}>();


</script>

<template>
  <div class="flex items-center gap-2">
    <template v-if="building.buildingCode == 'solar_collectors'">
      <GenericIconWithColoredNumber :amount="666666" type="energy"/>
    </template>
    <template v-else>
      <template v-for="effect in building.effects" :key="effect.type">
        <GenericIconWithColoredNumber v-if="effect.bonus != 0" :amount="effect.bonus" :type="effect.type"/>
      </template>
    </template>
  </div>
</template>

<style scoped lang="scss">

</style>